import React from "react";
import TabPosition from "../shared/TabPosition";
import { Helmet } from "react-helmet-async";
import { TranslationService } from "../../services/TranslationService";
import ConsolidatedDashboard from "./components/ConsolidatedDashboard";

const Consolidated: React.FC = () => {
  const { translate } = TranslationService;

  return (
    <TabPosition module="consolidated/dashboard">
      <Helmet>
        <title>Intiza - {translate.Consolidated}</title>
      </Helmet>
      <section className="dashboard">
        <ConsolidatedDashboard />
      </section>
    </TabPosition>
  );
};

export default Consolidated;
